import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useTenantRestoreManyMutation } from "@/v2-backoffice-client/tenant/restore/many/tenant.restore.many.mutation"

export type TenantRestoreManyButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  tenantIds: number[]
  onCompleted?(): void
}

function TenantRestoreManyButton(props: TenantRestoreManyButtonProps) {
  const { tenantIds, confirmContent, onCompleted, ...confirmButtonProps } =
    props
  const tenantCount = tenantIds.length

  const [restoreManyTenants, { loading, error }] = useTenantRestoreManyMutation(
    {
      onCompleted,
    },
  )

  errorToast(error, {
    title: `Failed to restore ${tenantCount} team(s)`,
  })

  return (
    <ConfirmButton
      id="tenant-restore-many-button"
      variant="success"
      confirmVariant="success"
      size="tiny"
      iconSrc="undo-alt"
      content="Restore teams"
      confirmContent={
        confirmContent ??
        `Are you sure you want to restore ${tenantCount} team(s)?`
      }
      isLoading={loading}
      onConfirm={() => {
        restoreManyTenants({ variables: { ids: tenantIds } })
      }}
      {...confirmButtonProps}
    />
  )
}

export default TenantRestoreManyButton
